import React, { ReactNode } from 'react';

export type DelayedProps = { waitBeforeShow: number; children: ReactNode };
export type DelayedState = { hidden: boolean };

class Delayed extends React.Component<DelayedProps, DelayedState> {
    private timeoutId: number | null = null;

    constructor(props: DelayedProps) {
        super(props);
        this.state = { hidden: true };
    }

    componentDidMount() {
        this.timeoutId = setTimeout(() => {
            this.setState({ hidden: false });
        }, this.props.waitBeforeShow);
    }

    componentWillUnmount() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }

    render() {
        return this.state.hidden ? '' : this.props.children;
    }
}

export default Delayed;
